export default __webpack_public_path__ + "static/uswitchBestValue2020-f23f5e5cec5a5fa36a5292513ba712ed.png";